export const useGlobalState = () => {
  const globalPageTitle = useState("globalPageTitle", () => "");
  const globalLastOpenedMenu = useState("globalLastOpenedMenu", () => "");

  return {
    globalPageTitle,
    globalLastOpenedMenu,
  };
};
